<template>
    <div>
        <UserNavigation/>
        <div class="container">
            <div class="row">
                <div class="col-sm" style="padding-top: 10px">
                    <CartItemTable/>
                </div>
            </div>
            <div class="button-row">
                <button class='checkout-button' @click="checkout">Naruči</button>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import router from '@/router'
    import UserNavigation from '@/component/user/UserNavigation'
    import CartItemTable from '@/component/user/cart/CartItemTable'

    export default {
        name: 'CartContainer',
        components: {
            UserNavigation,
            CartItemTable
        },
        computed: {
            ...mapGetters([
                'getTotalPrice',
                'getCartItems'
            ]),

            totalPrice: {
                get() {
                    return this.getTotalPrice
                }
            }
        },
        methods: {
            checkout() {
                if (this.getCartItems.length > 0)
                    router.push('checkout')
                else
                    this.$notify({
                        group: 'errors',
                        title: 'Greška pri kupovini',
                        text: 'Molimo Vas dadajte proizvod u korpu'
                    })
            }
        }
    }
</script>

<style scoped>
	* {
		background: #F0EAD6;
	}

    .button-row {
        display: flex;
        align-content: center;
        justify-content: space-between;
    }

    .checkout-button {
        background: transparent;
        color: #967bb6;
        text-transform: uppercase;
        font-size: 14px;
        font-weight: bold;
        width: 150px;
        padding: 10px;
        border: 1px solid #967bb6;
        border-radius: 0;
        cursor: pointer;
    }

    .checkout-button:hover,
    .checkout-button:active,
    .checkout-button:focus {
        background: transparent;
        border: 1px solid #6f5193 ;
        color: #6f5193 ;
    }
</style>
